/* This file was GENERATED from the Webflow capture, which has since been
 * retired — see DESIGN-SYSTEM-PLAN.md. There is no generator any more: this is
 * now ordinary source, and editing it by hand is how you change it.
 * The strip above the nav, on 18 of 59 routes. The capture carries two
 * different campaigns; `PROMO_VARIANT` in src/pages/index.ts records which
 * route ran which.
 */
import type { ReactElement } from 'react'
import { NavLink } from 'react-router'
import { wfActive } from '@/components/chrome/wf-active'

export type PromoVariant = "webinar" | "marketo" | "studio"

const VARIANTS: Record<PromoVariant, ReactElement> = {
  webinar: (
    /* On 17 of the 18 routes that carry a promo strip. */
    <div id={"promo-header"} className={"section-8"}>
      <a href={"https://singulatenbbcoreplatform.registration.goldcast.io/webinar/ce4dfb0c-839b-49aa-b083-d1504adf559a"} className={"link-9"}>
        Webinar: How I Doubled Pipeline Through Email Personalization 
        <strong className={"bold-text-21"}>
          Register now
        </strong>
      </a>
      <a href={"#"} className={"promo-close w-button"}>
        ✕
      </a>
    </div>
  ),
  studio: (
    /* The Oct 19, 2026 Studio launch strip. Copy written by Chad on launch day, audience from the press release; no price, trial or stat on purpose. */
    <div id={"promo-header"} className={"section-8"}>
      <NavLink to={"/studio"} className={wfActive("link-9")}>
        New: Singulate Studio. Personalized email for consultants, coaches and agency owners.{" "}
        <strong className={"bold-text-21"}>
          See Studio →
        </strong>
      </NavLink>
      <a href={"#"} className={"promo-close w-button"}>
        ✕
      </a>
    </div>
  ),
  marketo: (
    /* Homepage only. From the older Wayback recovery, so its copy is a different campaign — kept rather than overwritten, since which promo runs is a marketing decision, not a migration one. */
    <div id={"promo-header"} className={"section-8"}>
      <NavLink to={"/post/marketo-integration-personalization-segmentation"} className={wfActive("link-9")}>
        New Marketo integration! 
        <strong className={"bold-text-21"}>
          Read more
        </strong>
      </NavLink>
      <a href={"#"} className={"promo-close w-button"}>
        ✕
      </a>
    </div>
  ),
}

export function PromoBarMarkup({ variant }: { variant: PromoVariant }) {
  return VARIANTS[variant]
}
